import { Spinner } from "./Spinner"
import { useClassNames } from "../../../hooks/useClassNames"

type LoadingOverlayProps = {
  isVisible: boolean
  message?: string
  className?: string
}

export const LoadingOverlay = ({ isVisible, message = "Processing...", className }: LoadingOverlayProps) => {
  if (!isVisible) return null

  return (
    <div className={useClassNames(
      "fixed inset-0 z-[9999] flex flex-col items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm",
      className
    )}>
      <div className="bg-white rounded-lg p-6 shadow-lg flex flex-col items-center space-y-4">
        <Spinner size="lg" />
        <p className="text-gray-700 font-medium">{message}</p>
      </div>
    </div>
  )
}
